<div style="padding: 30px; min-width: 300px;">
  <div *ngIf="itProfiles && itProfiles.length == 0">
    No IT Profile has been associated with this project yet
  </div>
  <div *ngIf="itProfiles && itProfiles.length > 0">
    <div style="margin-top: 10px">
      <mat-form-field style="width: 100%;">
        <mat-label>Select Profile</mat-label>
        <mat-select [(value)]="itProfile" style="width: 200px;">
          <mat-option *ngFor="let profile of itProfiles" style="display: block; cursor: pointer;"
                      [value]="profile">{{ profile.name || 'Unnamed' }}
          </mat-option>
        </mat-select>
      </mat-form-field>


    </div>
    <div *ngIf="itProfile.isFedRamp">
      <mat-form-field>
        <mat-label>FedRAMP Version</mat-label>
        <mat-select [(ngModel)]="fedRampVersion">
          <mat-option [value]="4">v4</mat-option>
          <mat-option [value]="5">v5</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
      <button mat-raised-button (click)="generate()">Ok</button>
      <button mat-raised-button (click)="onClose()">Cancel</button>
    </div>
  </div>
</div>
